import React from 'react';

const PageContent = ({children}) => {
	return (
		<main className='col-12 col-lg-9 col-xl-10 pt-5 pb-3'>
			{children}
		</main>
	);
};

export default PageContent;
